<h1
  matDialogTitle
  class="h1-title"
  style="padding-left: 24px !important; padding-right: 24px !important"
>
  API CALL BENCHING
</h1>

<div mat-dialog-content class="benching-dialog-content">
  <div *ngIf="callStack" class="call-list">
    <div *ngFor="let call of callStack" class="call-item flex-row-start-center">
      <div class="call-item-inner">
        <div class="flex-row-start-center call-item-row">
          <div class="flex-column-center-center call-duration">
            <div class="blue-fg call-duration-value">
              {{ call.seconds }}
            </div>
            <div class="call-duration-unit">second(s)</div>
          </div>

          <div class="flex-column-start-start call-details">
            <div class="call-url">{{ call.url }}</div>
            <div class="mat-body-2 call-method">{{ call.method }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions class="benching-dialog-actions gt2-buttons-theme">
  <button
    mat-raised-button
    (click)="compDialogRef.close(false)"
    class="mat-fuse-dark-700-bg"
  >
    {{ "GENERIC.OK" | translate }}
  </button>
  <button mat-raised-button (click)="clearStack()" class="mat-fuse-dark-700-bg">
    {{ "GENERIC.CLEAR" | translate }}
  </button>
</div>
